export function splitToParagraphs(text: string): string[] {
  return text
    .replace(/\r/g, '\n')
    .split('\n')
    .filter((para) => para.length > 0);
}
